// export const domain = 'http://localhost:8000/';
// export const domain = 'https://ec-service.kisrasprint.com';
export const domain = 'https://ec-service.ksta.co/';
//production
// export const domain = 'https://service.irbrta-research.com/';
